import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Query orchid pro reminders
 */
export default async function queryOrchidProReminders(
  onBehalfOf?: string,
): Promise<AppointmentReminder[]> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/appointment_reminders/${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
